var version = {
    "name":      "dativery",
    "buildDateCode": "20260605-145407",
    "buildDate": "Fri Jun 05 2026 14:54:07 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260605-145407",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;